import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider,
} from "@mui/material";

const JoinNowInstructions = ({
  openInstruction,
  setOpenInstruction,
  onContinue,
}) => {
  return (
    <Dialog
      open={openInstruction}
      onClose={() => setOpenInstruction(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 16,
          padding: "3px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          fontSize: "20px",
          color: "#f77f00",
        }}
      >
        Before You Go Live 🚀
      </DialogTitle>

      <Divider />

      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
            Follow these quick steps:
          </Typography>

          <div
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              paddingRight: "5px",
              scrollbarWidth: "thin",
              scrollbarColor: "#f77f00 #ffe8cc",
            }}
            className="custom-scroll"
          >
            <ul style={{ lineHeight: "1.8", paddingLeft: "18px" }}>
              <li>You will be automatically redirected to YouTube Studio.</li>

              <li>
                Go to <b>Live → Stream</b> from the left sidebar.
              </li>

              <li>
                In the <b>Stream Settings</b>, copy your <b>Stream Key</b> and
                paste it into OBS or any streaming software.
              </li>

              <li>
                In OBS, choose <b>YouTube – RTMP</b> as the service and paste
                the Stream Key.
              </li>

              <li style={{ color: "#b86e00", fontWeight: "bold" }}>
                ⚠ IMPORTANT: Turn ON <b>"Allow Embedding"</b>.
              </li>

              <li>
                Correct location to enable <b>Allow Embedding</b>:
                <br />
                <b>
                  YouTube Studio → Content → Live → Select your livestream
                  <br />
                  Details → Show More → Allow Embedding (toggle ON)
                </b>
              </li>
            </ul>
          </div>
        </Box>

        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            background: "#fff8e6",
            border: "1px solid #ffd38b",
          }}
        >
          <Typography variant="body2" sx={{ color: "#b86e00" }}>
            ⚠ Keep your internet stable. Closing this tab will interrupt the
            live stream.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={() => setOpenInstruction(false)}
          sx={{
            textTransform: "none",
            color: "#333",
            fontWeight: 500,
            mr: 1,
          }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={() => {
            // setOpenInstruction(false);
            onContinue();
          }}
          sx={{
            backgroundColor: "#f77f00",
            textTransform: "none",
            color: "black",
            fontWeight: 600,
            px: 3,
            borderRadius: "10px",
            "&:hover": { backgroundColor: "#fb8c00" },
          }}
        >
          Continue to Live Studio →
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default JoinNowInstructions;
